import { ComponentProps } from "react";
import { createTheme } from "flowbite-react";

const h3Theme = createTheme({
  h3: {
    base: "text-lg sm:text-xl font-semibold",
    colors: {
      base: "text-foreground",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      error: "text-error",
    },
  },
}).h3;

type H3Props = {
  children: React.ReactNode
  color?: keyof typeof h3Theme.colors
  className?: string
} & ComponentProps<"h3">;

const H3 = ({
  children,
  color = "base",
  className = "",
  ...props
}: H3Props) => {
  return (
    <h3
      className={`${h3Theme.base} ${h3Theme.colors[color]} ${className}`}
      {...props}
    >
      {children}
    </h3>
  );
};

H3.displayName = "H3";

export { H3 };
export type { H3Props };
